import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userSliceReducer from "./slices/user";
import notificationSliceReducer from "./slices/notification";
import cmsSliceReducer from "./slices/cms";
import leventSliceReducer from "./slices/levent";

const rootReducer = combineReducers({
  user: userSliceReducer,
  notification: notificationSliceReducer,
  cms: cmsSliceReducer,
  levent: leventSliceReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export default store;
